import type Highcharts from 'highcharts';
import { type FC, useRef } from 'react';
import { HighchartsWidget } from 'src/pages/dashboards/HighchartsWidget';

type Props = {
  html: string;
};

export const RichTextWidgetHighcharts: FC<Props> = ({ html }) => {
  const textEl = useRef<Highcharts.SVGElement>();

  const options: Highcharts.Options = {
    chart: {
      type: 'richText',
      animation: false,
      events: {
        render: function () {
          if (textEl.current) {
            textEl.current.destroy();
          }
          const renderer = this.renderer;
          textEl.current = renderer
            .text(
              `<span style="text-wrap: auto; overflow: auto; max-width: 100%; max-height: 100%; display: block;">${html}</span>`,
              0,
              0,
              true
            )
            .css({
              overflow: 'auto',
              maxHeight: this.plotHeight + 'px',
              wordWrap: 'break-word',
            })
            .add();
        },
      },
    },
  };

  return <HighchartsWidget options={options} />;
};
